// extracted by mini-css-extract-plugin
module.exports = {"title":"AddSibling_title__25Sp7","button":"AddSibling_button__19fxh","row":"AddSibling_row__1P0x6","input":"AddSibling_input__2WZuZ"};